import { REGEX } from "../constants/regex";

export function validateInputs(inputText, inputMode) {
  let response = {};
  switch (inputMode) {
    case "NATIONAL_CODE": {
      if (inputText?.replaceAll(" ", "").length == 0) {
        response.isPass = false;
        response.message = "وارد کردن کد ملی الزامی است";
      } else if (!REGEX.NATIONAL_CODE.test(inputText)) {
        response.isPass = false;
        response.message = "کد ملی را صحیح وارد نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "PASSWORD": {
      if (inputText.length < 6 || inputText.length > 8) {
        response.isPass = false;
        response.message = "رمز عبور بایستی بین 6 الی 8 کاراکتر باشد";
      } else {
        response.isPass = true;
      }

      break;
    }
    case "PLATE": {
      if (!REGEX.PLATE.test(inputText)) {
        response.isPass = false;
        response.message = "پلاک را به درستی وارد نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "NUMBER": {
      if (!REGEX.NUMBER.test(inputText)) {
        response.isPass = false;
        response.message = "مقدار را به درستی وارد نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "STRING_fa": {
      if (!REGEX.STRING_fa.test(inputText)) {
        response.isPass = false;
        response.message = "فیلد را با حروف فارسی تکمیل نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "STR_NUM_en": {
      if (!REGEX.STR_NUM_en.test(inputText)) {
        response.isPass = false;
        response.message = "فیلدرا با اعداد و حروف انگلیسی تکمیل نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "STR_NUM_fa": {
      if (!REGEX.STR_NUM_fa.test(inputText)) {
        response.isPass = false;
        response.message = "فیلد را با اعداد و حروف فارسی تکمیل نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "STRING_fa_en": {
      if (!REGEX.STRING_fa_en.test(inputText)) {
        response.isPass = false;
        response.message = "مقدار را به درستی وارد نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "PHONE": {
      if (inputText?.replaceAll(" ", "").length == 0) {
        response.isPass = false;
        response.message = "وارد کردن شماره موبایل الزامی است";
      } else if (!REGEX.PHONE.test(inputText)) {
        response.isPass = false;
        response.message = "شماره موبایل را به درستی وارد نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "TEL": {
      if (!REGEX.TEL.test(inputText)) {
        response.isPass = false;
        response.message = " مقدار را به درستی وارد نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "ADDRESS": {
      if (!REGEX.ADDRESS.test(inputText)) {
        response.isPass = false;
        response.message = "مقدار را به درستی وارد نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "REPAIR_NUM": {
      if (!REGEX.REPAIR_NUM.test(inputText)) {
        response.isPass = false;
        response.message = "شناسه صنفی را به درستی وارد نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
    case "ALL": {
      if (!REGEX.ALL.test(inputText)) {
        response.isPass = false;
        response.message = " مقدار را به درستی وارد نمایید";
      } else {
        response.isPass = true;
      }
      break;
    }
  }

  return response;
}
